module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-dd-ap-a104fd5a.png";